import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface RecupererFormationsPorteusesResponseAgregeePourAffichage {
    codeFormationPorteuseDeCharge: string;
    succes: boolean;
    objetsConcernes: { codeObjet: string; message: string }[];
}

@Component({
    selector: 'app-resultats-recuperation-formations-porteuses-dialog',
    imports: [MatDialogModule, CommonModule, MatTableModule, MatCardModule, MatIconModule, MatButtonModule, MatTooltipModule],
    templateUrl: './resultats-recuperation-formations-porteuses-dialog.component.html',
    styleUrl: './resultats-recuperation-formations-porteuses-dialog.component.scss',
    animations: [
        trigger('detailExpand', [
            transition(':enter', [
                style({ height: '0px', minHeight: '0', opacity: '0' }),
                animate('425ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ height: '*', opacity: '1' }))
            ]),
            transition(':leave', [
                style({ height: '*', opacity: '1' }),
                animate('425ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ height: '0px', minHeight: '0', opacity: '0' }))
            ])
        ])
    ]
})
export class ResultatsRecuperationFormationsPorteusesDialogComponent {
    readonly data: {
        resultats: RecupererFormationsPorteusesResponseAgregeePourAffichage[];
    } = inject(MAT_DIALOG_DATA, { optional: false });

    expandedRows: Set<string> = new Set();

    isMultipleRow = (i, e: RecupererFormationsPorteusesResponseAgregeePourAffichage) => {
        return e.objetsConcernes.length > 1;
    };

    isExpandedRow(e) {
        return this.expandedRows.has(e.codeFormationPorteuseDeCharge);
    }

    toggleRowExpansion(element) {
        if (element.codeFormationPorteuseDeCharge) {
            if (this.expandedRows.has(element.codeFormationPorteuseDeCharge)) {
                this.expandedRows.delete(element.codeFormationPorteuseDeCharge);
            } else {
                this.expandedRows.add(element.codeFormationPorteuseDeCharge);
            }
        }
    }
}
